import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';

const EditMeetingForm = ({ meetingData, onSave, onCancel }) => {
  const [formData, setFormData] = useState(meetingData || {});
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.meetingWith) newErrors.meetingWith = 'This field is required';
    if (!formData.startTime) newErrors.startTime = 'This field is required';
    if (!formData.endTime) newErrors.endTime = 'This field is required';
    if (!formData.phone) newErrors.phone = 'This field is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm() && onSave) {
      onSave(formData);
    }
  };

  return (
    <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Edit Meeting
      </Typography>
      <TextField
        label="Meeting With"
        value={formData.meetingWith || ''}
        onChange={(e) => handleChange('meetingWith', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        error={!!errors.meetingWith}
        helperText={errors.meetingWith}
      />
      <TextField
        label="Start Time"
        type="time"
        value={formData.startTime || ''}
        onChange={(e) => handleChange('startTime', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        error={!!errors.startTime}
        helperText={errors.startTime}
      />
      <TextField
        label="End Time"
        type="time"
        value={formData.endTime || ''}
        onChange={(e) => handleChange('endTime', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        error={!!errors.endTime}
        helperText={errors.endTime}
      />
      <TextField
        label="Meet Method"
        value={formData.meetMethod || ''}
        onChange={(e) => handleChange('meetMethod', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Meet Mode"
        value={formData.meetMode || ''}
        onChange={(e) => handleChange('meetMode', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Phone"
        value={formData.phone || ''}
        onChange={(e) => handleChange('phone', e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        error={!!errors.phone}
        helperText={errors.phone}
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default EditMeetingForm;
